import { cloneDeep, omit } from 'lodash';
import { format } from 'date-fns';

import { getCountryName } from '../../../utils/textHelper';
import { DATE_FORMAT_US, DATE_FORMAT_US_SHORT } from '../../../constants/dateFormats';

export function getCountryNameFromRow(countries, countryCode) {
  return countries[countryCode] ? getCountryName(countries[countryCode], countryCode) : countryCode;
}

export function groupByDateAndRetailerId({ data, showYears }) {
  const grouped = {};

  data.forEach((datum) => {
    const { retailer_id: retailerId, date } = datum;
    const current = format(new Date(date), showYears ? DATE_FORMAT_US : DATE_FORMAT_US_SHORT);

    if (!grouped[current]) {
      grouped[current] = {};
    }

    if (grouped[current][retailerId]) {
      const currentGroup = grouped[current][retailerId];

      Object.keys(currentGroup.unit_count).forEach((key) => (currentGroup.unit_count[key] += datum.unit_count[key]));
      Object.keys(currentGroup.gmv).forEach((currency) => {
        Object.keys(currentGroup.gmv[currency]).forEach(
          (key) => (currentGroup.gmv[currency][key] += datum.gmv[currency][key]),
        );
      });
    } else {
      grouped[current][retailerId] = cloneDeep(omit(datum, 'date', 'hour'));
    }
  });
  return grouped;
}

export function getSalesByTopChannelsGraphTitle(retailerIds) {
  if (retailerIds.length) {
    if (retailerIds.length > 10) {
      return 'Sales by 10 top channels over time';
    } else {
      return retailerIds.length === 1
        ? 'Sales by channel over time'
        : `Sales by ${retailerIds.length} channels over time`;
    }
  }
  return '';
}
